import React, { useEffect, useContext } from "react";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { AxiosConfiguration } from "../../Utils/AxiosConfig";
import {
  clearManufacturerData,
  fillManufacturerData,
} from "../../redux/Admin/manufacturer";
import {
  SelectorCompanyName,
  SelectorListCountries,
  SelectorListStates,
  SelectorCompanyLogo,
  SelectorAddressLineOne,
  SelectorAddressLineTwo,
  SelectorCountry,
  SelectorState,
  SelectorCity,
  SelectorPinCode,
  SelectorErrorCompanyName,
  SelectorErrorCompanyLogo,
  SelectorErrorAddressLineOne,
  SelectorErrorCountry,
  SelectorErrorState,
} from "../../redux/Admin/selectorManufacturer";
import { globalInfo } from "../../App";
import { Redirect } from 'react-router-dom';

let AdminAddManufacturer = () => {
  const dispatch = useDispatch();
  const { ip_address } = useContext(globalInfo);
  const selectors = {
    listCountries: SelectorListCountries(),
    listStates: SelectorListStates(),
    companyName: SelectorCompanyName(),
    companyLogo: SelectorCompanyLogo(),
    addressLineOne: SelectorAddressLineOne(),
    addressLineTwo: SelectorAddressLineTwo(),
    country: SelectorCountry(),
    state: SelectorState(),
    city: SelectorCity(),
    pinCode: SelectorPinCode(),
    errorCompanyName: SelectorErrorCompanyName(),
    errorCompanyLogo: SelectorErrorCompanyLogo(),
    errorAddressLineOne: SelectorErrorAddressLineOne(),
    errorCountry: SelectorErrorCountry(),
    errorState: SelectorErrorState(),
  };
  const navigate = useNavigate();

  const manufacturerData = useSelector((state) => {
    const {
      companyName,
      companyLogo,
      addressLineOne,
      addressLineTwo,
      country,
      city,
      pinCode,
    } = state.manufacturer;
    return {
      company_name: companyName,
      company_logo: companyLogo,
      address1: addressLineOne,
      address2: addressLineTwo,
      country_id: country,
      state_id: state.manufacturer.state,
      city: city,
      zip_code: pinCode,
    };
  });

  useEffect(() => {
    async function fetchMyAPI() {
      const axios_instance = AxiosConfiguration();
      const response = await axios_instance.post("v1/get_country_list/");
      let optionItems = response.data.data.map((item) => (
        <option key={item.country_id} value={item.country_id}>
          {item.country_name}
        </option>
      ));

      dispatch(
        fillManufacturerData({
          fieldName: "listCountries",
          value: optionItems,
        })
      );
    }
    fetchMyAPI();
  }, []);

  let get_States = (country_id) => {
    if (country_id !== "") {
      let bodyFormData = new FormData();
      bodyFormData.append("country_id", country_id);
      async function fetchMyAPI() {
        const axios_instance = AxiosConfiguration();
        await axios_instance
          .post("v1/get_state_list/", bodyFormData)
          .then((response) => {
            if (response.data.status === "failure") {
              dispatch(
                fillManufacturerData({
                  fieldName: "listStates",
                  value: "",
                })
              );
            } else {
              if (response.data.data) {
                let optionItems = response.data.data.map((item) => (
                  <option key={item.state_id} value={item.state_id}>
                    {item.state_name}
                  </option>
                ));
                dispatch(
                  fillManufacturerData({
                    fieldName: "listStates",
                    value: optionItems,
                  })
                );
              }
            }
          })
          .catch((error) => {
            dispatch(
              fillManufacturerData({
                fieldName: "listStates",
                value: "",
              })
            );
          });
      }
      fetchMyAPI();
    } else {
      dispatch(
        fillManufacturerData({
          fieldName: "listStates",
          value: "",
        })
      );
    }
  };

  let validate_image = (image) => {
    if (!image.name.match(/\.(jpg|jpeg|png)$/)) {
      toast.warning("Select valid image", { autoClose: 1500 });
      dispatch(
        fillManufacturerData({
          fieldName: "companyLogo",
          value: "",
        })
      );
      return false;
    }

    if (image.size > 2000000) {
      toast.warning("Maximum filesize limit exceeded", { autoClose: 1500 });
      dispatch(
        fillManufacturerData({
          fieldName: "companyLogo",
          value: "",
        })
      );
      return false;
    }
  };
  let handleImageChange = (image) => {
    dispatch(
      fillManufacturerData({
        fieldName: "companyLogo",
        value: image,
      })
    );
  };
  let submit_manufacturer = () => {
    let errorRequiredFiled = 0;
    if (selectors.companyName === "") {
      dispatch(
        fillManufacturerData({
          fieldName: "errorCompanyName",
          value: "Can not be empty",
        })
      );
      errorRequiredFiled += 1;
    }

    if (selectors.companyLogo === "") {
      dispatch(
        fillManufacturerData({
          fieldName: "errorCompanyLogo",
          value: "Can not be empty",
        })
      );
      errorRequiredFiled += 1;
    }

    if (selectors.addressLineOne === "") {
      dispatch(
        fillManufacturerData({
          fieldName: "errorAddressLineOne",
          value: "Can not be empty",
        })
      );
      errorRequiredFiled += 1;
    }

    if (selectors.country === "") {
      dispatch(
        fillManufacturerData({
          fieldName: "errorCountry",
          value: "Can not be empty",
        })
      );
      errorRequiredFiled += 1;
    }

    if (selectors.state === "") {
      dispatch(
        fillManufacturerData({
          fieldName: "errorState",
          value: "Can not be empty",
        })
      );
      errorRequiredFiled += 1;
    }

    if (errorRequiredFiled > 0) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      return false;
    }

    const bodyFormData = new FormData();

    for (let key in manufacturerData) {
      bodyFormData.append(key, manufacturerData[key]);
    }

    bodyFormData.append("entered_by", 1);
    bodyFormData.append("entered_by_ip", ip_address);
    bodyFormData.append("status", 1);
    async function fetchMyAPI() {
      const axios_instance = AxiosConfiguration();
      await axios_instance
        .post("v1/create_manufacturer/", bodyFormData)
        .then((response) => {
          if (response.data.status === "success") {
            dispatch(clearManufacturerData());
            document.getElementById("companyLogo").value = "";

            dispatch(
              fillManufacturerData({
                fieldName: "companyLogo",
                value: "",
              })
            );
            dispatch(
              fillManufacturerData({
                fieldName: "listStates",
                value: "",
              })
            );
            toast.success(response.data.message, { autoClose: 1500 });
            // window.location.href = `/AdminListManufacturer`;
            navigate( `/AdminListManufacturer`)
          } else {
            toast.warning(response.data.message, { autoClose: 1500 });
          }
        })
        .catch((error) => {
          toast.error("Something went wrong  try again", { autoClose: 1500 });
        });
    }
    fetchMyAPI();
  };

  return (
    <div>
      
      <div className="wrapper">
        <div>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-default">
                      <div className="card-header">
                        <div className="card-tools">
                          <div className="col-md-12">
                            <Link
                              to="/AdminListManufacturer"
                              className="btn btn-sm custom-btn-primary"
                            >
                              <i className="fa fa-arrow-left"></i> Back
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <form
                          method="post"
                          action="post"
                          encType="multipart/form-data"
                        >
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  Company Name<i className="text-danger">*</i>
                                </span>
                                <input
                                  type="text"
                                  className={
                                    "form-control" +
                                    (selectors.errorCompanyName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder="Company Name"
                                  name="companyName"
                                  value={selectors.companyName}
                                  onChange={(e) => {
                                    dispatch(
                                      fillManufacturerData({
                                        fieldName: e.target.name,
                                        value: e.target.value,
                                      })
                                    );
                                    dispatch(
                                      fillManufacturerData({
                                        fieldName: "errorCompanyName",
                                        value: "",
                                      })
                                    );
                                  }}
                                  maxLength={255}
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  Company Logo<i className="text-danger">*</i>
                                  <small> (max file size 2MB)</small>
                                </span>
                                <input
                                  type="file"
                                  accept="image/*"
                                  className={
                                    "form-control" +
                                    (selectors.errorCompanyLogo
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="companyLogo"
                                  name="companyLogo"
                                  onChange={(e) => {
                                    dispatch(
                                      fillManufacturerData({
                                        fieldName: e.target.name,
                                        value: e.target.value,
                                      })
                                    );
                                    dispatch(
                                      fillManufacturerData({
                                        fieldName: "errorCompanyLogo",
                                        value: "",
                                      })
                                    );
                                    validate_image(e.target.files[0]);
                                    handleImageChange(e.target.files[0]);
                                  }}
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  Address Line - 1
                                  <i className="text-danger">*</i>
                                </span>
                                <input
                                  type="text"
                                  className={
                                    "form-control" +
                                    (selectors.errorAddressLineOne
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder="Address Line - 1"
                                  value={selectors.addressLineOne}
                                  name="addressLineOne"
                                  onChange={(e) => {
                                    dispatch(
                                      fillManufacturerData({
                                        fieldName: e.target.name,
                                        value: e.target.value,
                                      })
                                    );
                                    dispatch(
                                      fillManufacturerData({
                                        fieldName: "errorAddressLineOne",
                                        value: "",
                                      })
                                    );
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  Address Line - 2
                                </span>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="addressLineTwo"
                                  placeholder="Address Line - 2"
                                  value={selectors.addressLineTwo}
                                  onChange={(e) => {
                                    dispatch(
                                      fillManufacturerData({
                                        fieldName: e.target.name,
                                        value: e.target.value,
                                      })
                                    );
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  Country<i className="text-danger">*</i>
                                </span>
                                <select
                                  className={
                                    "form-control custom-select" +
                                    (selectors.errorCountry
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="country"
                                  name="country"
                                  value={selectors.country}
                                  onChange={(e) => {
                                    dispatch(
                                      fillManufacturerData({
                                        fieldName: e.target.name,
                                        value: e.target.value,
                                      })
                                    );
                                    dispatch(
                                      fillManufacturerData({
                                        fieldName: "errorCountry",
                                        value: "",
                                      })
                                    );
                                    get_States(e.target.value);
                                  }}
                                >
                                  <option value="">Select</option>
                                  {selectors.listCountries}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  State<i className="text-danger">*</i>
                                </span>
                                <select
                                  className={
                                    "form-control custom-select" +
                                    (selectors.errorState ? " is-invalid" : "")
                                  }
                                  id="state"
                                  name="state"
                                  value={selectors.state}
                                  onChange={(e) => {
                                    dispatch(
                                      fillManufacturerData({
                                        fieldName: e.target.name,
                                        value: e.target.value,
                                      })
                                    );
                                    dispatch(
                                      fillManufacturerData({
                                        fieldName: "errorState",
                                        value: "",
                                      })
                                    );
                                  }}
                                >
                                  <option value="">Select</option>
                                  {selectors.listStates}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  City
                                </span>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="City"
                                  name="city"
                                  value={selectors.city}
                                  onChange={(e) => {
                                    dispatch(
                                      fillManufacturerData({
                                        fieldName: e.target.name,
                                        value: e.target.value,
                                      })
                                    );
                                  }}
                                  maxLength={150}
                                />
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="form-group">
                                <span className="custom-label-font-weight">
                                  Zip/Postal Code
                                </span>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Zip/Postal Code"
                                  value={selectors.pinCode}
                                  name="pinCode"
                                  onChange={(e) => {
                                    dispatch(
                                      fillManufacturerData({
                                        fieldName: e.target.name,
                                        value: e.target.value,
                                      })
                                    );
                                  }}
                                  maxLength={50}
                                />
                              </div>
                            </div>

                            <div className="col-md-12">
                              <button
                                type="button"
                                className="btn btn-sm custom-btn-primary pull-right"
                                onClick={submit_manufacturer}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminAddManufacturer;
